<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Word-Root',
  data() {
    return {};
  },
};
</script>
